import { createSlice } from "@reduxjs/toolkit";

export const soundsSlice = createSlice({
  name: "sounds",
  initialState: {
    isSoundtrackMute: true,
    isSoundEffectsMute: false,
  },
  reducers: {
    setIsSoundtrackMute: (state, action) => {
      state.isSoundtrackMute = action.payload;
    },
    setIsSoundEffectsMute: (state, action) => {
      state.isSoundEffectsMute = action.payload;
    },
  },
});

export const { setIsSoundtrackMute, setIsSoundEffectsMute } =
  soundsSlice.actions;

export default soundsSlice.reducer;
